import React, {Component} from 'react';
import {translate} from 'react-i18next';

class ProfileUserBlock extends Component {

    constructor(props) {
        super(props);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.reloadUser = this.reloadUser.bind(this);
    }

    componentDidMount() {
        this.props.getUser();
    }

    reloadUser() {
        this.props.getUser();
    }

    handleFormSubmit(e) {
        e.preventDefault();
        let {user} = this.props;
        this.props.handleFormSubmit(user);
    }

    render() {
        const {t, user} = this.props;
        return (
            <div className="ibox ProfileUserBlock">
                <form className="form-inline-edit" onSubmit={this.handleFormSubmit}>
                    <div className="ibox-title">
                        <h5>{t('profileScreen.user.title')}</h5>
                        <div className="ibox-tools">
                            {user.edit ? (
                                <div>
                                    <a onClick={this.reloadUser} className="btn btn-default m-r-xs">
                                        <i className="fa fa-undo"/>
                                    </a>
                                    <button type="submit" className="btn btn-primary"
                                            disabled={user.loading}>
                                        {user.loading ? (
                                            <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                        ) : null}
                                        <i className="fa fa-save"/>
                                    </button>
                                </div>
                            ) : (
                                <a onClick={this.props.editUser}>
                                    <i className="fa fa-pencil fa-1-5x"/>
                                </a>
                            )}
                        </div>
                    </div>
                    <div className="ibox-content">
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((user.errors && user.errors.username) ? ' has-error' : '')}>
                                    <label>{t('user.username.label')}</label>
                                    <input className="form-control" name="username" value={user.username}
                                           readOnly={!user.edit}
                                           onChange={this.props.handleTextInputChange}/>
                                    {(user.errors && user.errors.username) ? (
                                        <span className="help-block">
                                            {t('user.username.error.' + user.errors.username)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        {user.edit ? (
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className={"form-group" + ((user.errors && user.errors.changePassword) ? ' has-error' : '')}>
                                        <div className="checkbox checkbox-primary">
                                            <input name="changePassword" id="checkboxChangePassword" defaultChecked={user.changePassword} type="checkbox" onChange={this.props.handleCheckboxInputChange}/>
                                            <label htmlFor="checkboxChangePassword">
                                                {t('user.changePassword.label')}
                                            </label>
                                        </div>
                                        {(user.errors && user.errors.changePassword) ? (
                                            <span className="help-block">
                                            {t('user.changePassword.error.' + user.errors.changePassword)}
                                        </span>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {user.edit && user.changePassword ? (
                            <div>
                                <div className="row">
                                    <div className="col-xs-6">
                                        <div
                                            className={"form-group" + ((user.errors && user.errors.oldPassword) ? ' has-error' : '')}>
                                            <label>{t('user.oldPassword.label')}</label>
                                            <input className="form-control" name="oldPassword" value={user.oldPassword}
                                                   readOnly={!user.edit} type="password"
                                                   onChange={this.props.handleTextInputChange}/>
                                            {(user.errors && user.errors.oldPassword) ? (
                                                <span className="help-block">
                                            {t('user.oldPassword.error.' + user.errors.oldPassword)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6">
                                        <div
                                            className={"form-group" + ((user.errors && user.errors.newPassword1) ? ' has-error' : '')}>
                                            <label>{t('user.newPassword1.label')}</label>
                                            <input className="form-control" name="newPassword1" value={user.newPassword1}
                                                   readOnly={!user.edit} type="password"
                                                   onChange={this.props.handleTextInputChange}/>
                                            {(user.errors && user.errors.newPassword1) ? (
                                                <span className="help-block">
                                            {t('user.newPassword1.error.' + user.errors.newPassword1)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-xs-6">
                                        <div
                                            className={"form-group" + ((user.errors && user.errors.newPassword2) ? ' has-error' : '')}>
                                            <label>{t('user.newPassword2.label')}</label>
                                            <input className="form-control" name="newPassword2" value={user.newPassword2}
                                                   readOnly={!user.edit} type="password"
                                                   onChange={this.props.handleTextInputChange}/>
                                            {(user.errors && user.errors.newPassword2) ? (
                                                <span className="help-block">
                                            {t('user.newPassword2.error.' + user.errors.newPassword2)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </form>
            </div>
        )
    }
}

export default translate()(ProfileUserBlock);